import { UserManagerSettings } from 'oidc-client';

export const environment = {
  production: true,
  env: 'prod',
  hmr: false,
  registryUrl: 'https://registry.prod.browsermodules.ihsmarkit.com',
  apiBaseUrl: 'https://api.polaris.ihsmarkit.com',
  wsUrl: 'wss://gateway.sockets.ipreo.com/connect',
  enableRouterTracing: false,
  instrumentStore: false,
  loadLocalDevModules: false,
  groupName: 'USG-Muni_SellSide_Users',
  splunkRumToken: 't5z3X2sv9z8RCu9sMaqvTg',
  splunkSessionReplayEnabled:false,
  oidcSettings: {
    authority:
      'https://sam.ihsmarkit.com/sso/oauth2/realms/root/realms/Customers',
    client_id: 'GlobalMarkets-Polaris-prod-mEGZVK137v',
    redirect_uri: 'https://globalmarkets.ihsmarkit.com',
    post_logout_redirect_uri: 'https://globalmarkets.ihsmarkit.com',
    response_type: 'code',
    scope: 'openid email profile saml_attributes',
    automaticSilentRenew: true,
    silentRequestTimeout: 10000,
    filterProtocolClaims: true,
    loadUserInfo: true,
  } as UserManagerSettings,
};
